const getCurrencySymbol = (currency) => {
    const currencyUpper = (currency || "").toUpperCase();
    switch (currencyUpper) {
        case "INR":
            return String.fromCodePoint(8377);
        case "USD":
        case "USDT":
            return String.fromCodePoint(36);
        case "EUR":
            return String.fromCodePoint(8364);
        case "GBP":
            return String.fromCodePoint(163);
        case "JPY":
        case "CNY":
            return String.fromCodePoint(165);
        case "BTC":
            return "₿";
        case "ETH":
            return "Ξ";
        default:
            return currencyUpper;
    }
};

export default getCurrencySymbol;
